export function sortArray(arr: any[], reverse: boolean = false): any[] {
    return reverse
        ? arr.sort((b, a) => (a > b) ? 1 : ((b > a) ? -1 : 0))
        : arr.sort((a, b) => (a > b) ? 1 : ((b > a) ? -1 : 0));
}

export function sortArrayOfObjects(arr: any[], property: string, reverse: boolean = false): any[] {
    return reverse
        ? arr.sort((b, a) => (a[property] > b[property]) ? 1 : ((b[property] > a[property]) ? -1 : 0))
        : arr.sort((a, b) => (a[property] > b[property]) ? 1 : ((b[property] > a[property]) ? -1 : 0));
}

export function filterArrayContainsValue(arr: any[], value: string, properties: string[]): any[] {
    const ret: any[] = [];
    if (!value) {
        return [];
    }
    arr.map(item => {
        for (const property of properties) {
            let error: boolean = false;
            const split: string[] = property.split('.');
            let itemValue = item;
            let i = 0;
            while (i < split.length) {
                if (itemValue[split[i]]) {
                    itemValue = itemValue[split[i]];
                    i++;
                } else {
                    error = true;
                    itemValue = null;
                    i = split.length;
                    return;
                }
            }
            const finalValue: string = itemValue.toString().toUpperCase();

            if (finalValue.indexOf(value.toString().toUpperCase()) != -1) {
                ret.push(item);
                return;
            }

        }
    });
    return ret;
}
